import { ArtsApiRemoteService } from '../../Services/api/arts/arts-service'
import { ICreateArtPayload } from '../../Services/api/arts/arts.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreateArtsUseCase
implements IFormUsecase<ICreateArtPayload, void> {
  constructor (private readonly ArtsApi: ArtsApiRemoteService) {}
    

  public async handle (
    data: ICreateArtPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ArtsApi.create(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
